import type {
  KnowledgeBaseLayoutPayloadNode,
  KnowledgeBaseTreeApiCategory,
  KnowledgeBaseTreeApiItem,
  KnowledgeBaseTreeNode,
} from "models/knowledge-base/knowledge-base-tree.types";

const isApiItem = (
  node: KnowledgeBaseTreeApiItem | KnowledgeBaseTreeApiCategory,
): node is KnowledgeBaseTreeApiItem => node.type === "item";

export const apiTreeToNodes = (
  categories: KnowledgeBaseTreeApiCategory[],
): KnowledgeBaseTreeNode[] =>
  categories.map((category) => mapApiCategory(category));

const mapApiCategory = (
  category: KnowledgeBaseTreeApiCategory,
): KnowledgeBaseTreeNode => ({
  type: "category",
  uuid: category.uuid,
  title: category.title,
  order: category.order,
  children: (category.children ?? []).map((child) =>
    isApiItem(child)
      ? {
          type: "item",
          uuid: child.uuid,
          title: child.title,
          slug: child.slug,
          order: child.order,
          isPublished: child.is_published,
        }
      : mapApiCategory(child),
  ),
});

export const nodesToPayload = (
  nodes: KnowledgeBaseTreeNode[],
): KnowledgeBaseLayoutPayloadNode[] =>
  nodes.map((node, index) => serializeNode(node, index));

const serializeNode = (
  node: KnowledgeBaseTreeNode,
  index: number,
): KnowledgeBaseLayoutPayloadNode => {
  if (node.type === "item") {
    return { type: "item", uuid: node.uuid, order: index };
  }

  return {
    type: "category",
    uuid: node.uuid,
    title: node.title,
    order: index,
    children: node.children.map((child, childIndex) =>
      serializeNode(child, childIndex),
    ),
  };
};
